import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DownArrowIcon } from "../../../components/ui/Swicons";
import { titleCase } from "../../../utils";

export default function RecipientItem({ recipient, _deleteRecipient }) {
  const [collapse, setCollapse] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handelClickSend = () => {
    navigate("/Add-Transaction", {
      state: { ...location.state, recipient: recipient },
    });
  };
  

  return (
    <>
      <tr
        key={"transaction-table-" + recipient._id}
        className={`${collapse ? "border-b" : ""}`}
      >
        <td className="py-3 pr-8 text-xs lg:text-sm text-left text-gray-800">
          {recipient.recipient_nick_name} <br/>({titleCase(recipient.recipient_name)})
        </td>
        <td className=" py-3 text-xs lg:text-sm text-center text-gray-800">
          {recipient.bank_account_number}
        </td>
        <td className="py-3 text-xs lg:text-sm text-center text-gray-800">
          <p className={recipient.is_deleted ? "sw-cancelled lg:w-2/6 mx-auto" : "sw-completed w-4/6 lg:w-2/6 mx-auto"}>
            {recipient.is_deleted ? "Inactive" : "Active"}
          </p>
        </td>
        <td className="py-3 px-4 text-xs lg:text-sm text-gray-800">
          <div className="flex justify-center">
            {recipient.is_deleted && null}
            {!recipient.is_deleted && (
              <button
                className="sw-completed w-20 cursor-pointer bg-themeColor hover:bg-gray-200"
                onClick={() => handelClickSend(recipient._id)}
              >
                Send
              </button>
            )}{" "}
            <button className="px-2" data-test="collapse" onClick={() => setCollapse((v) => !v)}>
              <DownArrowIcon />
            </button>
          </div>
        </td>
      </tr>
      {collapse ? null : (
        <tr className="bg-white rounded-b w-full border-b py-2 h-full text-xs lg:text-sm text-gray-800">
          <td>IFSC Code: {recipient.ifsccode}</td>
          <td></td>
          <td></td>
          <td className="py-2 text-sm flex justify-center text-gray-800">
            {!recipient.is_deleted ? (
              <button
                className="sw-cancelled w-20 hover:bg-red-500 hover:text-red-200 cursor-pointer mr-10"
                onClick={() => _deleteRecipient(recipient._id)}
              >
                Delete
              </button>
            ) : null}
          </td>
        </tr>
      )}
    </>
  );
}
